module.exports = __webpack_public_path__ + "img/child-of-love3.bebe441d.jpg";